import store from '@/store';

export default () => {
  store.dispatch('account/getAccount', store.getters['auth/getAuthToken']);
};



// WEBPACK FOOTER //
// ./src/services/account/decrypt.js